import {doVxqlRequest} from './common.js';
import Flux            from '../../Flux';
import Constants       from '../../Constants';

const MediaLibraryVideoAsset = `
    ...on MediaLibraryVideoAsset {
        asset {
            id
	        title
	        duration
	        released
            vip
            ageRating
            description(full: true)
	        preview {
	            id
	            aspectRatio
	            images(size: [w320, w640, w1280], placeholder: true) {
	                size
	                url
	            }
	        }
	        previewThumbnails(first: 100) {
	            id
	            aspectRatio
	            images(size: [w320, w640, w1280], placeholder: true) {
	                size
	                url
	            }
	        }
	        model {
	            id
	            name
	            linkVX(internal: true)
                online
                avatar {
                    url(size: w60)
                }
	        }
	        linkVX(internal: true)
			url(profile: hls)
			previewVideo {
			    url
			}
			guestInfo {
			    bought
			    gifted
			}
			price {
			    value
			    currency
			}
			basePrice {
			    value
			    currency
			}
        }
    }
`;

const MediaLibraryGalleryAsset = `
    ...on MediaLibraryGalleryAsset {
        asset {
			id
	        title
	        description
	        ageRating
	        free
	        guestInfo {
	            bought
	            gifted
	            liked
	            flatrate
	        }
	        price {
	            value
	            currency
	        }
	        basePrice {
	            value
	            currency
	        }
	        preview {
	            id
	            aspectRatio
	            images(size: [w320, w640, w1280], placeholder: true) {
	                size
	                url
	            }
	        }
	        previews {
	            id
	            width
	            height
	            aspectRatio
	            orientation
	            images(size: [w320, w640, w1280], placeholder: true) {
	                size
	                url
	            }
	        }
	        rating {
	            likes
	        }
	        model {
	            id
	            name
	            linkVX(internal: true)
                online
                avatar {
                    url(size: w60)
                }
	        }
	        linkVX(internal: true)
			isVipContent
        }
    }
`;

function getAssetByType(type) {
    switch (type) {
        case Constants.Mediathek.MediaType.PHOTO:
            return MediaLibraryGalleryAsset;
        case Constants.Mediathek.MediaType.VIDEO:
        default:
            return MediaLibraryVideoAsset;
    }
}

export function loadMediaLibraryData(args, callback) {
    const asset = getAssetByType(args.filter.mediaType);

    const query = `
	query GetMediaLibraryData(
        $filter: MediaLibraryFilter,
        $first: Int = 20,
        $offset: Int = 0,
        $search: String = "",
        $order: ModelVideosOrder = ${Flux.Constants.Vxql.MyVisitXMediathekSort.NEWEST}
    ) {
		guest {
		  mediaLibrary_v2 {
            assets(filter: $filter, first: $first, offset: $offset, order: $order, search: $search) {
                total
                items {
                    ${asset}
                }
            }
          }
		}
	  }
	`;

    doVxqlRequest(query, args).then((result) => {
        const data = result.data.guest.mediaLibrary_v2.assets;
        callback(data); // Pass data directly to the callback
    });
}

export function loadMediaTotals(callback) {
    const query = `
query LoadMediaTotals {
  guest {
    stats: mediaLibrary_v2 {
        stats {
          videos
          photos
          audio
        }
    }
  }
}
    `;

    doVxqlRequest(query).then((result) => {
        const data = result.data.guest.stats.stats;
        callback({
            videos: data.videos,
            photos: data.photos,
            audio:  data.audio,
        });
    });
}

export default {
    loadMediaLibraryData,
    loadMediaTotals,
};
